import styled from 'styled-components';

export const Footer = styled.footer`
  background-color: ${({ theme }) => theme.footer.bgColor};
`;
